var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDuplicate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.999,
    height: 12,
    viewBox: "0 0 11.999 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-253.573 218.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4v9.323H9.325V4Zm8.606,8.6H.719V4.711H8.606Z",
    transform: "translate(253.573 -220.162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.323,0V9.325H11.378V8.606H12.6V.713H4.717V1.945H4V0Z",
    transform: "translate(252.25 -218.839)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDuplicate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/duplicate.1d0404ca03a8122182a7114cf6bb9e81.svg";